import type { System } from '../../systems';
import type { EngineEffect } from '../../visual';

export class TrailUpdateSystem implements System {
  readonly id = 'trail-update';

  constructor(private readonly trails: readonly EngineEffect[]) {}

  update(dt: number): void {
    for (const trail of this.trails) {
      trail.update(dt);
    }
  }

  dispose(): void {
    for (const trail of this.trails) {
      trail.object3D.removeFromParent();
      trail.dispose();
    }
  }
}
